// extracted by mini-css-extract-plugin
export default {"container":"order-modal_container__fcQui","panel":"order-modal_panel__baFhe","option-panel":"order-modal_option-panel__PWYji","button":"order-modal_button__wovaP"};